import { createContext } from 'use-context-selector';
import { AccountExtraitTransactionDetailsProviderState } from './types';
import { defaultAccountExtraitTransactionDetailsProviderState } from './defaultState';

const AccountExtraitTransactionDetailsContext = createContext<AccountExtraitTransactionDetailsProviderState>(
  defaultAccountExtraitTransactionDetailsProviderState,
);

export { AccountExtraitTransactionDetailsContext };
